import React, { useContext, useEffect, useState } from 'react'
import FormPhone from '../FormPhone'
import FormEmail from '../FormEmail'
import { AdCommonEvents, callPixelEvent, ContextApp } from '@monorepo/service'
import { useLogin } from '@monorepo/api'

declare const window: Window &
  typeof globalThis & {
    updateContent?: any
  }

const Layout = () => {
  const { isCdaCheck, isCdaBalancerInfoLoading, cdaBalancerInfo } = useContext(ContextApp)
  const [mode, setMode] = useState<'phone' | 'email'>('phone')
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [initialStyle, setInitialStyle] = useState<React.CSSProperties>()
  const { origin, redirectToLoginPage } = useLogin({
    geo: 'KZ',
    isBalancerInfoLoading: isCdaBalancerInfoLoading,
    balancerInfo: cdaBalancerInfo,
  })

  useEffect(() => {
    if (isCdaCheck) {
      callPixelEvent({ event: AdCommonEvents.Visit })
      callPixelEvent({ event: AdCommonEvents.LandingPageView })
      callPixelEvent({ event: AdCommonEvents.RegNotFinished })
    }
  }, [isCdaCheck])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const regType = params.get('reg_type')
    if (regType === 'email' || regType === 'phone') {
      setMode(regType)
    }

    const flexDir = regType === 'phone' ? 'row-reverse' : undefined
    setInitialStyle({
      flexDirection: flexDir,
    })

    const script = document.createElement('script')
    script.type = 'module'
    script.src = '/assets/js/index.js'
    script.crossOrigin = ''
    script.onload = () => {
      window.updateContent?.()
      setScriptLoaded(true)
    }
    document.head.appendChild(script)
    return () => void document.head.removeChild(script)
  }, [])

  useEffect(() => {
    if (scriptLoaded) {
      window.updateContent?.()
    }
  }, [mode, scriptLoaded])

  return (
    <>
      <header className="header">
        <nav className="nav">
          <div className="nav__btn">
            <a
              className="button"
              data-cy="login-button"
              data-origin={origin}
              data-i18n="global.login"
              onClick={redirectToLoginPage}
            >
              Логин
            </a>
          </div>

          <div className="nav__languages">
            <div className="langSelector" id="languageSwitcher">
              <div className="selected">
                <img src="./flags/ru.svg" alt="RU" />
                <span>RU</span>
                <div className="selected-icon">
                  <img
                    src="data:image/svg+xml,%3csvg%20width='12'%20height='8'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.41.58L6%205.17%2010.59.58%2012%202%206%208%200%202%201.41.58z'%20fill='%23fff'/%3e%3c/svg%3e"
                    alt="Win"
                  />
                </div>
              </div>
              <ul className="dropdown-list"></ul>
            </div>
          </div>
        </nav>
      </header>

      <main className="main">
        <img
          src="./assets/img/overlay-bg.png"
          alt="Win"
          className="estop main__overlay fadeInPulse"
          loading="lazy"
        />

        <section className="hero">
          <div className="hero__container container">
            <img
              src="./assets/img/chips-0.png"
              alt="Win"
              className="estop absolute main__chips-0 flyingDown d-md-none"
            />
            <img
              src="./assets/img/chips-02.png"
              alt="Win"
              className="estop absolute main__chips-0 flyingDown d-none d-md-block"
            />

            <div className="hero__form" id="hero__form">
              <div className="hero__form-logo">
                <img src="./assets/img/logo.svg" alt="BoostWin" className="estop" />
              </div>
              <div className="hero__form-title">
                <span data-i18n="hero.title-heading">Ваш бонус на первый депозит: </span>
                <br />
                <span data-i18n="hero.title-line-1"> 1 500 000 ₸</span>
                <br />
                <span data-i18n="hero.title-line-2">+ 180 FS!</span>
              </div>
              <div className="hero__form-content">
                <div className="hero__form-toggle" style={initialStyle}>
                  <div
                    className={mode === 'email' ? 'active' : ''}
                    onClick={() => setMode('email')}
                    data-i18n="hero.toggle.email"
                  >
                    Почта
                  </div>
                  <div
                    className={mode === 'phone' ? 'active' : ''}
                    onClick={() => setMode('phone')}
                    data-i18n="hero.toggle.phone"
                  >
                    Телефон
                  </div>
                </div>

                {mode === 'phone' ? <FormPhone /> : <FormEmail />}
              </div>
            </div>
          </div>
        </section>

        {/* Мобильные изображения */}
        <div className="d-md-none">
          <img src="./assets/img/girl-1.png" alt="Win" className="estop absolute main__girl-1" />
          <img src="./assets/img/girl-2.png" alt="Win" className="estop absolute main__girl-2" />
          <img
            src="./assets/img/chips-1.png"
            alt="Win"
            className="estop absolute main__chips-1 flyingDown"
          />
          <img
            src="./assets/img/chips-2.png"
            alt="Win"
            className="estop absolute main__chips-2 flyingUp"
          />
          <img
            src="./assets/img/chips-3.png"
            alt="Win"
            className="estop absolute main__chips-3 flyingUp"
          />
          <img
            src="./assets/img/chips-4.png"
            alt="Win"
            className="estop absolute main__chips-4 flyingDown"
          />
        </div>

        {/* Планшетные изображения */}
        <div className="d-none d-md-block d-xl-none">
          <img
            src="./assets/img/tablet/girl-1.png"
            alt="Win"
            className="estop absolute main__girl-1"
          />
          <img
            src="./assets/img/tablet/girl-2.png"
            alt="Win"
            className="estop absolute main__girl-2"
          />
          <img
            src="./assets/img/tablet/chips-1.png"
            alt="Win"
            className="estop absolute main__chips-1 flyingDown"
          />
          <img
            src="./assets/img/tablet/chips-2.png"
            alt="Win"
            className="estop absolute main__chips-2 flyingUp"
          />
          <img
            src="./assets/img/tablet/chips-3.png"
            alt="Win"
            className="estop absolute main__chips-3 flyingDown"
          />
          <img
            src="./assets/img/tablet/chips-4.png"
            alt="Win"
            className="estop absolute main__chips-4 flyingUp"
          />
          <img
            src="./assets/img/tablet/chips-5.png"
            alt="Win"
            className="estop absolute main__chips-5 flyingDown"
          />
        </div>

        {/* Десктопные изображения */}
        <div className="d-none d-xl-block">
          <img
            src="./assets/img/desktop/girl-1.png"
            alt="Win"
            className="estop absolute main__girl-1"
          />
          <img
            src="./assets/img/desktop/girl-2.png"
            alt="Win"
            className="estop absolute main__girl-2"
          />
          <img
            src="./assets/img/desktop/chips-1.png"
            alt="Win"
            className="estop absolute main__chips-1 flyingDown"
          />
          <img
            src="./assets/img/desktop/chips-2.png"
            alt="Win"
            className="estop absolute main__chips-2 flyingUp"
          />
          <img
            src="./assets/img/desktop/chips-3.png"
            alt="Win"
            className="estop absolute main__chips-3 flyingDown"
          />
          <img
            src="./assets/img/desktop/chips-4.png"
            alt="Win"
            className="estop absolute main__chips-4 flyingUp"
          />
          <img
            src="./assets/img/desktop/chips-5.png"
            alt="Win"
            className="estop absolute main__chips-5 flyingDown"
          />
          <img
            src="./assets/img/desktop/chips-6.png"
            alt="Win"
            className="estop absolute main__chips-6 flyingDown"
          />
          <img
            src="./assets/img/desktop/chips-7.png"
            alt="Win"
            className="estop absolute main__chips-7 flyingUp"
          />
        </div>
      </main>
    </>
  )
}

export default Layout
